import { UserResponse } from './../../models/auth/user.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServerResponse } from '../data/models/server-response';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(public httpClient: HttpClient) { }

  getBasePath(): string {
    return environment.apiUrl + 'user/';
  }
  
  validateWorker(code: string): Observable<UserResponse>{
    const url = this.getBasePath() + 'validate/' + code;
    return this.httpClient.get<UserResponse>(url);
  }

  validateResponsible(code: string): Observable<any>{
    const url = this.getBasePath() + 'validateResponsable/' + code;
    return this.httpClient.get<any>(url);
  }

  getClaims(): Observable<string[]> {
    const url = this.getBasePath() + 'claim';
    return this.httpClient.get<ServerResponse<string>>(url).pipe(
      map((responseData) => {
        const items = responseData.values;
        return items;
      }),
    );
  }
}
